import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { useLang } from "../../lib/i18n";
import { api, errMsg } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Field } from "../../components/site/ProfileFields";
import { AuthShell } from "./Login";

export function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email, origin: window.location.origin });
      setRes(data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthShell>
      <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
        <h1 className="font-display text-4xl font-extrabold text-[#0A2540]">{t("forgot_password")}</h1>
        <p className="text-slate-500">{t("forgot_intro")}</p>
        {res ? (
          <div className="space-y-3 rounded-2xl bg-cyan-50 p-5 text-sm text-[#0A2540]" data-testid="forgot-sent">
            <p className="flex items-center gap-2 font-semibold"><MailCheck size={18} className="text-[#00A8B5]" />{t("reset_sent")}</p>
          </div>
        ) : (
          <>
            <Field label={t("email")}><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" data-testid="forgot-email-input" /></Field>
            <button disabled={busy} className="btn-buoy w-full justify-center disabled:opacity-60" data-testid="forgot-submit">{t("send_reset_link")}</button>
          </>
        )}
        <Link to="/login" className="block text-sm font-semibold text-slate-500" data-testid="forgot-back-login">{t("back")} · {t("login")}</Link>
      </form>
    </AuthShell>
  );
}

export function ResetPassword() {
  const { t } = useLang();
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [f, setF] = useState({ password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.password !== f.confirm) return toast.error(t("passwords_mismatch"));
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token: sp.get("token") || "", password: f.password });
      toast.success(t("password_updated"));
      nav("/login");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthShell>
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <h1 className="font-display text-4xl font-extrabold text-[#0A2540]">{t("new_password")}</h1>
        <Field label={t("password")}><Input type="password" required minLength={6} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className="h-12 rounded-xl" data-testid="reset-password-input" /></Field>
        <Field label={t("confirm_password")}><Input type="password" required minLength={6} value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className="h-12 rounded-xl" data-testid="reset-confirm-input" /></Field>
        <button disabled={busy} className="btn-buoy w-full justify-center disabled:opacity-60" data-testid="reset-submit">{t("save")}</button>
      </form>
    </AuthShell>
  );
}
